import { render, staticRenderFns } from "./PricingPageHeader.vue?vue&type=template&id=7f06f5b6&scoped=true&"
import script from "./PricingPageHeader.vue?vue&type=script&lang=js&"
export * from "./PricingPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PricingPageHeader.vue?vue&type=style&index=0&id=7f06f5b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f06f5b6",
  null
  
)

export default component.exports